<nk-layout-centered columnClasses="col-lg-10 col-sm-12">
  <ng-container *ngIf="identity">
    <h4>{{ 'login.authenticated.title' | translate }}</h4>
    <p
      class="text-muted"
      [innerHtml]="
        'login.authenticated.you_are_logged_in_as'
          | translate: { userName: identity.app_user.name, customerName: identity.app_customer.name }
      "></p>
    <nk-spinner></nk-spinner>
    <button type="button" class="btn btn-danger px-4" (click)="logoutAndRedirectToLogin.emit()">
      {{ 'login.authenticated.logout' | translate }}
    </button>
    <button type="button" class="btn btn-primary px-4" (click)="dashboardClick.emit()">
      {{ 'login.authenticated.dashboard' | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="!identity && identityList && identityList.length > 1">
    <h6>
      {{ 'login.authenticated.welcome' | translate: { userName: identityList[0].app_user.name } }}
      <ng-container *ngIf="identityList[0].app_user.admin_flag">(Enin Admin)</ng-container>
    </h6>
    <h4>{{ 'login.authenticated.choose_customer.title' | translate }}</h4>
    <p
      class="text-muted"
      [innerHtml]="'login.authenticated.choose_customer.you_have_multiple_customer_memberships' | translate"></p>

    <div style="max-height: 400px; overflow-y: scroll" *ngIf="appRoleDims$ | async as appRoleDimsDict">
      <div *ngIf="adminIdentityList.length">
        <button
          *ngFor="let adminIdentity of adminIdentityList"
          (click)="customerClick.emit(adminIdentity.app_customer.slug)"
          type="button"
          class="btn btn-info style-inline-block m-1">
          {{ adminIdentity.app_customer.name }}
          <span
            *ngIf="appRoleDimsDict[adminIdentity.app_membership.uuid]?.flags.superuser"
            class="badge badge-light badge-pill ms-1"
            >{{ 'login.authenticated.choose_customer.superuser' | translate }}</span
          >
          <span
            *ngIf="appRoleDimsDict[adminIdentity.app_membership.uuid]?.flags.customer_admin"
            class="badge badge-light badge-pill ms-1"
            >{{ 'login.authenticated.choose_customer.admin' | translate }}</span
          >
        </button>
      </div>
      <div class="mt-2">
        <button
          *ngFor="let identityData of identityList"
          (click)="customerClick.emit(identityData.app_customer.slug)"
          type="button"
          class="btn btn-outline-primary style-inline-block m-1 normal-case">
          {{ identityData.app_customer.name }}
          <span class="badge badge-primary badge-pill ms-1">
            {{ identityData.app_customer.slug }}
          </span>
        </button>
      </div>
    </div>
    <div class="text-right">
      <button (click)="logoutAndRedirectToLogin.emit()" type="button" class="btn btn-danger px-4">
        {{ 'login.authenticated.logout' | translate }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="!identity && identityList && identityList.length === 0">
    <h4>{{ 'login.authenticated.title' | translate }}</h4>
    <p class="text-muted" [innerHtml]="'login.authenticated.help' | translate"></p>
    <button type="button" class="btn btn-danger px-4" (click)="logoutAndRedirectToLogin.emit()">
      {{ 'login.authenticated.logout' | translate }}
    </button>
  </ng-container>
</nk-layout-centered>
